<template>
    <span v-if="store && store.attributes && store.attributes.hasOwnProperty('address')" class="d-flex flex-row">
        <span v-if="flag && store.attributes.address.country">
            <CountryFlag class="mr-1" :country='store.attributes.address.country' size='normal' :rounded="true"/>
        </span>
        <span class="address">
            <span>{{ store.attributes.address.street1 }},&nbsp;</span>
            <span>{{ store.attributes.address.postcode }} {{ store.attributes.address.city }}</span>
            <span v-if="store.attributes.address.state">{{ store.attributes.address.state }}</span>
        </span>
    </span>
</template>

<script>
import CountryFlag from 'vue-country-flag';

export default {
    components: {CountryFlag},

    props: {
        store: Object,
        flag: Boolean,
    },
};
</script>
